import { z } from 'zod';
/**
 * Der Antwortvertrag der Länderliste — `V-vertrag3` (2026-08-29).
 *
 * `apps/api/src/countries/countries.service.ts` führte `CountryView` bislang
 * als eigene Form; der OpenAPI-Erzeuger blieb an `GET /api/v1/countries`
 * deshalb `[UNGEKLÄRT]`.
 */
/** Ein Land, wie es die Auswahlfelder der Oberfläche brauchen. */
export const countryViewSchema = z
    .object({
    code: z.string(),
    nameDe: z.string(),
})
    .strict();
/**
 * Die Antworthülle von `GET /api/v1/countries` — `{ countries: [...] }`. Der Umschlag lebt neben seinem
 * Elementschema, damit Server und Oberfläche dieselbe Hülle prüfen (Handbuch §3.969).
 */
export const countryListResponseSchema = z.object({ countries: z.array(countryViewSchema).readonly() }).strict();
//# sourceMappingURL=countries.js.map